import { render, staticRenderFns } from "./UEdit.vue?vue&type=template&id=dce9e52e&scoped=true"
import script from "./UEdit.vue?vue&type=script&lang=js"
export * from "./UEdit.vue?vue&type=script&lang=js"
import style0 from "./UEdit.vue?vue&type=style&index=0&id=dce9e52e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce9e52e",
  null
  
)

export default component.exports